import { Component } from 'react';

import HelpButton from 'shared/components/button/HelpButton';
import { getText } from 'shared/utils/Text';

export default class ArchiveWarning extends Component {
  render() {
    return (
      <div className="archive-warning fgrid fgrid--center">
        <div className="fgrid-cell">
          <p>{getText('dialog-archive-warning')}</p>
        </div>
        <div className="fgrid-cell fgrid-cell--autoSize">
          <HelpButton
            header={getText('dialog-archive-download-help-title')}
            body={getText('dialog-archive-download-help-text')}
          />
        </div>
        <hr />
      </div>
    );
  }
}
